/**
 * @constant {String}
 */
export const FIO_REQID_HEADER = 'X-Fio-ReqId';

/**
 * @constant {String}
 */
export const OTA_LITE_SERVICE_HEADER = 'ota-lite-svc';

/**
 * @constant {String}
 */
export const CONTENT_TYPE_HEADER = 'Content-Type';

/**
 * @constant {String}
 */
export const DEFAULT_CONTENT_TYPE = 'application/json; charset=UTF-8';

/**
 * @constant {String}
 */
export const CONSENT_COOKIE_NAME = 'fio_consent';

/**
 * @constant {String}
 * @default
 */
export const DEFAULT_TIME_ZONE = 'UTC';

/**
 * @constant {String}
 * @default
 */
export const DEFAULT_LOCALE = 'en';

/**
 * @constant {String}
 * @default
 */
export const GITHUB_LOGIN_PROVIDER = 'github';

/**
 * @constant {String}
 * @default
 */
export const GOOGLE_LOGIN_PROVIDER = 'google';
